import { useTranslation } from 'react-i18next';
import { CollapseBlock } from '../../../../common/index.jsx';
import React from 'react';
import { Col, Row, Form as AntForm } from 'antd';
import { DATETIME_FORMAT_DATETIME } from '../../../../../utils/helpers/CommonHelper.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';
import { SubmitButton } from '../../../../common/form/FormElements.jsx';
import dayjs from 'dayjs';
import FormRangeDatePicker from '../../../../antd/form/FormRangeDatePicker/FormRangeDatePicker.jsx';
import { SensorAttributeSelect } from './SensorAttributeSelect.jsx';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import { isUndefined } from 'lodash';
import { PredefinedRangeDatePickerValues } from './PredefinedRangeDatePickerValues.jsx';

const types = (t) => ({
  MIN: t('Minimum'),
  MAX: t('Maximum'),
  AVERAGE: t('Priemer'),
});

export function StatisticsForm({
  sensorsWithGraphableAttributes,
  statisticsData,
  onSubmit,
}) {
  const { t } = useTranslation();
  const [form] = AntForm.useForm();

  return (
    <CollapseBlock collapsible title={t('Štatistiky')}>
      <Row>
        <Col lg={12} span={24}>
          <Form onFinish={onSubmit} form={form}>
            <h3 className="meteo-station-tip-title">
              1. {t('Vyberte, ktorý atribút senzora chcete použiť')}
            </h3>

            <SensorAttributeSelect
              name={'meteo_sensor_attribute_id'}
              label={t('Atribút senzora')}
              sensorWithAttributes={sensorsWithGraphableAttributes}
            />

            <h3 className="meteo-station-tip-title">
              2. {t('Vyberte časové obdobie')}
            </h3>

            <FormRangeDatePicker
              label={t('Časové obdobie')}
              name={'dates'}
              className="meteo-station-field"
              showTime
              format={DATETIME_FORMAT_DATETIME}
              disabledDate={(current) =>
                current && current > dayjs().endOf('day')
              }
              rules={[required(t)]}
            />
            <PredefinedRangeDatePickerValues
              onValueChange={(value) => form.setFieldValue('dates', value)}
            />

            <h3 className="meteo-station-tip-title">
              3. {t('Vyberte štatistiku')}
            </h3>

            <FormSelect
              label={t('Štatistika')}
              name={'type_of_statistics'}
              className="meteo-station-field"
              options={[
                {
                  label: t('Minimum'),
                  value: 'MIN',
                },
                {
                  label: t('Maximum'),
                  value: 'MAX',
                },
                {
                  label: t('Priemer'),
                  value: 'AVERAGE',
                },
              ]}
              rules={[required(t)]}
            />

            <Row justify={'start'}>
              <SubmitButton icon={<i className="fa-solid fa-calculator"></i>}>
                {t('Zobraziť danú štatistiku')}
              </SubmitButton>
            </Row>
          </Form>
        </Col>
        <Col lg={12} span={24}>
          {!isUndefined(statisticsData) ? (
            <article className="meteo-station-statistics-wrapper">
              <h4>{t('Štatistika pre vybrané parametre')}</h4>

              <div className="meteo-station-statistics-desc">
                <p>{t('Senzor')}:</p>
                <strong>{statisticsData.attribute.sensor.name}</strong>
              </div>

              <div className="meteo-station-statistics-desc">
                <p>{t('Atribút senzora')}:</p>
                <strong>
                  {statisticsData.attribute.label} [
                  {statisticsData.attribute.attribute_unit.unit}]
                </strong>
              </div>

              <div className="meteo-station-statistics-desc">
                <p>{t('Typ štatistiky')}:</p>
                <strong>{types(t)[statisticsData.type_of_statistics]}</strong>
              </div>

              <div className="meteo-station-statistics-result">
                <p>{t('Výsledok')}:</p>

                <strong>
                  {new Intl.NumberFormat('sk-SK', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 10,
                  }).format(statisticsData.value)}
                </strong>
              </div>
            </article>
          ) : null}
        </Col>
      </Row>
    </CollapseBlock>
  );
}
